/**
 * MAB API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SpecialTabEnum } from './specialTabEnum';


export interface SpecialTabInfo { 
    tabType: SpecialTabEnum;
    clientIdField: string;
    excludedDocs?: Array<number> | null;
    includedDocs?: Array<number> | null;
    noNew: boolean;
}

